import { Link } from 'react-router-dom';
import { movies } from '@/mocks/movies';

export default function HeroSection() {
  const featured = movies.filter((m) => m.isHot).slice(0, 3);

  return (
    <section className="relative w-full h-[520px] md:h-[640px] overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Cinematic%20movie%20theater%20interior%20with%20warm%20red%20velvet%20curtains%20and%20golden%20stage%20lights%2C%20dramatic%20spotlight%20effects%2C%20luxurious%20atmosphere%2C%20dark%20ambient%20background%20with%20subtle%20bokeh%2C%20elegant%20and%20artistic%20composition%2C%20rich%20crimson%20and%20gold%20color%20palette&width=1600&height=900&seq=hero-bg-01&orientation=landscape"
          alt="人人影院 - 免费高清在线观看"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/60"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center px-4 md:px-6">
        <div className="text-center max-w-3xl mb-10">
          <h2 className="text-accent-400 text-sm md:text-base font-medium mb-3 tracking-wider">
            RENREN CINEMA
          </h2>
          <h1 className="text-3xl md:text-5xl font-bold text-background-50 mb-4 leading-tight font-heading">
            免费高清在线观看
            <span className="block text-accent-400 mt-1">不缓冲 · 不卡顿 · 每日更新</span>
          </h1>
          <p className="text-sm md:text-base text-background-50/70 max-w-xl mx-auto leading-relaxed">
            海量影视资源一站式观看平台，涵盖最新电影、热门电视剧、动漫、综艺、纪录片。
            无需会员，打开即看，畅享极致观影体验。
          </p>
        </div>

        <div className="hidden md:grid grid-cols-3 gap-4 w-full max-w-3xl">
          {featured.map((movie) => (
            <Link
              key={movie.id}
              to={`/detail/${movie.id}`}
              className="group relative overflow-hidden rounded-xl aspect-[3/4] cursor-pointer transform transition-all duration-300 hover:scale-105 hover:z-20"
            >
              <img
                src={movie.imageUrl}
                alt={movie.title}
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-4">
                <span className="inline-block bg-accent-500 text-background-50 text-xs font-bold px-2 py-0.5 rounded mb-2 whitespace-nowrap">
                  HOT
                </span>
                <h3 className="text-base font-bold text-background-50 mb-1">
                  {movie.title}
                </h3>
                <p className="text-xs text-background-50/60 line-clamp-1">
                  {movie.description}
                </p>
              </div>
            </Link>
          ))}
        </div>

        <div className="md:hidden flex items-center gap-3 mt-6">
          <Link
            to="/category/dianying"
            className="bg-primary-500 hover:bg-primary-600 text-background-50 px-6 py-3 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200"
          >
            立即观影
          </Link>
          <Link
            to="/about"
            className="bg-background-50/20 hover:bg-background-50/30 text-background-50 border border-background-50/30 px-6 py-3 rounded-full text-sm font-medium whitespace-nowrap cursor-pointer transition-all duration-200"
          >
            了解更多
          </Link>
        </div>
      </div>
    </section>
  );
}